/* import __COLOCATED_TEMPLATE__ from './features-list-item.hbs'; */
import Component from '@glimmer/component';

export default class FeaturesListItem extends Component {}
